/* eslint-disable quotes */
import type { ColorFont, ColorSchema, Palette, Theme } from "themes/interfaces";
import { BaseBorder, BaseColor, BaseFont, BaseMargin } from "themes/base";
import { Enums } from "utils";

const theme: Theme = {
  id: Enums.EnumTheme.Light,
  font: BaseFont,
  color: BaseColor,
  palette: {
    theme: "#f5fbff",
    shadow: { color: "#d0d0d0", accent: "" } as ColorSchema,
    font: { color: "#404040", accent: "#606060" } as ColorFont,
    background: { color: "#ffffff", accent: "#efefef" } as ColorSchema,
  } as Palette,
  border: BaseBorder,
  margin: BaseMargin,
  disabled: {
    color: "rgba(0, 0, 0, 0.26)",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
  },
  special: "#ffffdf",
};

export const Light = theme;
